import {Button, Form, Modal} from 'antd';
import {WeaDialog, WeaTableEdit, WeaCheckbox, WeaInput, WeaNewScroll, WeaFormItem, WeaError} from 'ecCom';
import CoworkConstant from '../../../util/CoworkConstant';
import {inject, observer} from "mobx-react";
import {toJS} from 'mobx';
import {WeaColorPicker} from 'ecCom';

const FormItem = Form.Item;
import {WeaLocaleProvider} from 'ecCom';

const getLabel = WeaLocaleProvider.getLabel;

class TagForm extends React.Component {
  constructor(props) {
    super(props);
    this.initColor = '#6aa84f';
    this.state = {
      datas: props.datas,
      checkAll: props.datas.every((data) => {
        return data.isUsed == 1
      }),
      colorIdx: -1,
      color: this.initColor,
      selectRowKeys: []
    };
  }

  componentDidMount() {
    this.props.initFunc && this.props.initFunc(this);
  }

  render() {
    let {datas, colorIdx, color, selectRowKeys} = this.state;
    let {height} = this.props;
    return (
      <Form inline>
        <WeaTableEdit columns={this.getFormColumns(this.props.form)} datas={datas} title={getLabel(382640, '协作标签')}
                      onChange={this.onChange}
                      selectedRowKeys={selectRowKeys}
                      addPosition="first"
                      getRowSelection={this.getRowSelection}
                      onRowSelect={(keys) => {
                        this.setState({selectRowKeys: keys});
                      }}
                      tableProps={{scroll: {y: height - 91}}}
                      copyFilterProps={["id"]}
        />
        <WeaDialog visible={colorIdx != -1} title={`${getLabel(31214, '标签颜色')}${getLabel(130599, '设置')}`}
                   icon={CoworkConstant.iconClassName} iconBgcolor={CoworkConstant.iconBgColor}
                   style={{width: 300, height: 87}}
                   onCancel={this.backColor}
                   buttons={[
                     <Button type="primary" onClick={this.saveColor}>{getLabel(86, '保存')}</Button>,
                   ]}>
          <div className='wea-cowrk-tagset'>
            <WeaColorPicker onChange={this.changeColor} value={color}/>
          </div>
        </WeaDialog>
      </Form>
    );
  }

  getTagColor = (text, record, index) => {
    if (record.labelType == 'typePlate') {
      return null;
    }
    let color = (text && text != 'null') ? text : this.initColor;
    return (
      <span style={{backgroundColor: color, color: "#fff"}} className="tag-color"
            onClick={this.openColor.bind(this, index, color)}>{color}</span>
    );
  }

  getFormColumns = (form) => {
    const {getFieldProps} = form;
    let tagColumns = [
      {
        title: getLabel(81323, '标签名称'),
        dataIndex: 'labelName',
        key: 'labelName',
        width: '30%',
        render: (text, record, index) => {
          let colProps = getFieldProps(`labelArray[${index}].labelName`, {
            // rules: [
            //   {
            //     validator: (rule, value, callback) => {
            //       if (!value) {
            //         callback(getLabel(81327, '请输入标签名称'));
            //       } else
            //         callback();
            //
            //     }
            //   }
            // ],
            initialValue: text,
            onChange: this.changeName.bind(this, index)
          });
          if (record.labelType == 'typePlate') {
            colProps.viewAttr = 1;
          }else {
            colProps.viewAttr = 3;
          }
          return <WeaFormItem>
            <WeaError tipPosition='bottom'
                      ref='weaError'
                      error={getLabel('81323，83626', '标签名称为必填')}>
              <WeaInput {...colProps}
                        value={text}
              />
            </WeaError>
          </WeaFormItem>
        }
      },
      {
        title: getLabel(31214, '标签颜色'),
        dataIndex: 'labelColor',
        key: 'labelColor',
        width: '30%',
        render: this.getTagColor
      },
      {
        title: (
          <div>
            <WeaCheckbox onChange={this.checkAll} value={this.state.checkAll}/>
            <span className="ml5">{getLabel(382641, 'TAB标签显示')}</span>
          </div>
        ),
        dataIndex: 'isUsed',
        key: 'isUsed',
        width: '40%',
        render: (text, record, index) => {
          let colProps = getFieldProps(`labelArray[${index}].isUsed`, {
            initialValue: text == 1
          });
          return (
            <div>
              <WeaCheckbox {...colProps} value={text} onChange={this.checkOne.bind(this, index)}/>
            </div>
          );
        }
      }
    ];
    return tagColumns;
  }

  validateFieldsAndScroll = (callback) => {
    let {datas = []} = this.state;
    let saveParams = {};
    let canSave = true;
    //名称必填校验
    datas.map(v => {
      if (!v.labelName || v.labelName.split(' ').join('').length == 0) {
        canSave = false;
      }
    });
    if (!canSave) {
      Modal.error({
        title: getLabel(15172,'系统提示'),
        content: getLabel('81323，83626', '标签名称为必填')
      });
    }else {
      //处理数据：这里的数据经常有问题，要处理下
      saveParams = datas.map((data, idx) => {
        let param = {...data};
        if (!param.id && !param.labelType) {
          param.labelType = 'label';
          if (!param.labelColor)
            param.labelColor = this.initColor;
        }
        param.isUsed = (param.isUsed == true || param.isUsed == 1) ? 1 : 0;
        return param;
      });
    }
    return saveParams;
  }

  onChange = (datas) => {
    let checkAll = datas.every((data) => {
      return data.isUsed == 1
    })
    this.setState({
      datas: datas,
      checkAll: checkAll
    });
  }

  checkAll = (bool) => {
    let datas = this.state.datas.map((data) => {
      return {...data, isUsed: bool};
    });
    this.setState({
      datas: datas,
      checkAll: bool
    });
  }

  checkOne = (index, bool) => {
    let data = {...this.state.datas[index]};
    data.isUsed = bool;
    let datas = [...this.state.datas];
    datas[index] = data;
    this.onChange(datas);
  }

  openColor = (index, color) => {
    this.setState({
      colorIdx: index,
      color: color
    });
  }
  saveColor = () => {
    let data = {...this.state.datas[this.state.colorIdx]};
    data.labelColor = this.state.color;
    let datas = [...this.state.datas];
    datas[this.state.colorIdx] = data;
    this.setState({
      datas: datas
    });
    this.backColor();
  }
  backColor = () => {
    this.setState({
      colorIdx: -1,
      color: '#d9d9d9'
    });
  }
  changeColor = (color) => {
    this.setState({
      color: color
    });
  }
  reset = () => {
    this.setState({
      datas: this.props.datas,
      selectRowKeys: []
    });
    this.props.form.setFieldsValue({labelArray: this.props.datas});
  }

  getRowSelection = (rowSelection) => {
    let sel = {...rowSelection};
    sel.getCheckboxProps = (record) => {
      return {disabled: record.labelType == 'typePlate'};
    }
    return sel;
  }
  changeName = (index, value) => {
    let datas = [...this.state.datas];
    datas[index] = {...datas[index], labelName: value};
    this.setState({datas});
  }
}

TagForm = Form.create()(TagForm);


@inject("coworkMainStore")
@observer
class CoworkTagDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 600
    }
  }

  render() {
    let {height} = this.state;
    const {coworkMainStore} = this.props;
    const {config} = coworkMainStore;
    const {labelList, tagVisible} = toJS(config);
    return (
      <WeaDialog
        className='wea-cowork-tag'
        visible={tagVisible}
        title={`${getLabel(31214, '标签颜色')}${getLabel(130599, '设置')}`}
        icon={CoworkConstant.iconClassName}
        iconBgcolor={CoworkConstant.iconBgColor}
        style={{width: 800, height: 600}}
        onCancel={this.back}
        onChangeHeight={this.changeHeight}
        buttons={[
          <Button type="primary" onClick={this.submit}>{getLabel(86, '保存')}</Button>,
        ]}>
        <div className="wea-cowork-dialog tag-table-div">
          <TagForm initFunc={(form) => this.form = form} datas={labelList} height={height}/>
        </div>
      </WeaDialog>
    );
  }

  open = () => {
    const {coworkMainStore} = this.props;
    coworkMainStore.setTagVisible(true);
  }

  back = () => {
    const {coworkMainStore} = this.props;
    coworkMainStore.setTagVisible(false);
    this.form.reset();
  }

  submit = () => {
    const {coworkMainStore} = this.props;
    let values = this.form.validateFieldsAndScroll(); //做校验，改数据
    if(Object.keys(values).length !== 0){
      let params = {labelArray: JSON.stringify(values)};
      coworkMainStore.uploadCoworkLabelList(params, () => {
        coworkMainStore.getCoworkLabelList(this.back);
      });
    }
  }

  changeHeight = (height) => {
    this.setState({height});
  }
}

export default CoworkTagDialog;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/components/cowork/dialog/CoworkTagDialog.js